import { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { OLITASK_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const API_BASE_URL = `${OLITASK_SERVICE_BASE_URL}/api/v1/donations/donor`;

export default function useDonorDonations(
  authToken,
  donorId,
  page = 0,
  pageSize = 10
) {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // pagination state
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);

  // handle axios errors
  const handleAxiosErrors = (err, action = "operation") => {
    let message = "An unexpected error occurred.";
    if (err.response) {
      message =
        err.response.data?.message ||
        `Failed to ${action}: ${err.response.statusText}`;
    } else if (err.request) {
      message =
        "No response from the server. Please check your internet connection.";
    } else {
      message = err.message || "Something went wrong.";
    }
    setError(message);
    toast.error(message);
    console.error(`${action} error:`, err);
  };

  // Fetch all donations of a given donor
  const fetchDonorDonations = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiClient.get(
        `${API_BASE_URL}/${donorId}?page=${page}&size=${pageSize}`,
      );
      const data = res.data;
      setDonations(data.content);
      setTotalPages(data.totalPages || 1);
        setTotalElements(data.totalElements || 0);
        console.log("Response", data.content);
      //   return data.content;
    } catch (err) {
      handleAxiosErrors(err, "Fetch donor donations");
    } finally {
      setLoading(false);
    }
  }, [authToken, donorId, page, pageSize]);

  // fetch automatically when donor id changes
  useEffect(() => {
    if (authToken) fetchDonorDonations();
  }, [authToken, donorId, fetchDonorDonations]);

  return {
    donations,
    loading,
    error,
    totalPages,
    totalElements,
  };
}
